import * as React from "react";

import { storeValue, hasStoredValue } from '../storage/storage-utils';
import Spinner from '../common/Spinner';

/**
 * The purpose of this component is to set a storage flag to 
 * allow pre-launch app access 
 **/
const Preview = () => {
  const previewKey = 'preview';
  const hash = window.location.hash || ''; 

  if (hasStoredValue(previewKey)) {
    window.location.replace(`/${hash}`);  
  } else {
    storeValue(previewKey, true);
    window.setTimeout(() => {
      window.location.replace(`/${hash}`);
    }, 500);
  }
  return <Spinner />;
}

export default Preview;